__turbopack_context__.v({
  "bottom": "SiteFooter-module__KkLyMa__bottom",
  "colIdentity": "SiteFooter-module__KkLyMa__colIdentity",
  "colLabel": "SiteFooter-module__KkLyMa__colLabel",
  "cols": "SiteFooter-module__KkLyMa__cols",
  "footer": "SiteFooter-module__KkLyMa__footer",
  "inner": "SiteFooter-module__KkLyMa__inner",
  "link": "SiteFooter-module__KkLyMa__link",
  "list": "SiteFooter-module__KkLyMa__list",
  "liveNote": "SiteFooter-module__KkLyMa__liveNote",
  "tagline": "SiteFooter-module__KkLyMa__tagline",
  "wordmark": "SiteFooter-module__KkLyMa__wordmark",
});
